import createReactComponent from '../createReactComponent';
export default createReactComponent('file-export', 'IconFileExport', [
  ['path', { d: 'M14 3v4a1 1 0 0 0 1 1h4', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3',
      key: 'svg-1',
    },
  ],
]);
